import React, { Component } from 'react';
import PropTypes from 'prop-types';

let id = 0;

/*
 * Component that displays an SVG gradient representing a color legend
 */
class Legend extends Component {
  static propTypes = {
    // Width of the rectangle
    width: PropTypes.number.isRequired,

    // Height of the rectangle
    height: PropTypes.number.isRequired,

    // d3 color function mapping [0,1] to a color
    color: PropTypes.func.isRequired,

    // Array of numbers to map color range
    range: PropTypes.arrayOf(PropTypes.number),
  };

  static defaultProps = {
    range: [0, 0.25, 0.5, 0.75, 1],
  };

  constructor(props) {
    super(props);
    id += 1;
    this.id = id;
  }

  render() {
    const stopFunction = (value, idx, range) => {
      const scoreRange = range[range.length - 1] - range[0];
      const scorePct = (100 * (range[idx] - range[0])) / scoreRange;
      return (
        <stop
          key={idx}
          offset={`${scorePct}%`}
          style={{ stopColor: this.props.color(value) }}
        />
      );
    };

    return (
      <div>
        <svg
          className="legend"
          width={this.props.width + 60}
          height={this.props.height}
        >
          <defs>
            <linearGradient
              id={`legend${this.id}`}
              x1="0%"
              y1="0%"
              x2="100%"
              y2="0%"
              spreadMethod="pad"
            >
              {this.props.range.map(stopFunction)}
            </linearGradient>
          </defs>
          <rect
            width={this.props.width}
            height={this.props.height}
            x="25"
            y="0"
            fill={`url(#legend${this.id})`}
          />
          <text x="0" y={this.props.height / 2 + 5}>
            {this.props.range[0]}
          </text>
          <text x={this.props.width + 30} y={this.props.height / 2 + 5}>
            {this.props.range[this.props.range.length - 1]}
          </text>
        </svg>
      </div>
    );
  }
}

export default Legend;
